// src/pages/CancelPage.js
import React from "react";
import styled from "styled-components";
import Navbar from "../components/webpage/Navbar";
import Footer from "../components/webpage/Footer";
import { useNavigate } from "react-router-dom";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Navbar />
      <Content>
        <h2>❌ Płatność została anulowana</h2>
        <p>Twoja płatność nie została zrealizowana. Możesz spróbować ponownie.</p>
        <button onClick={() => navigate("/")}>
        Wróć do strony głównej
        </button>
      </Content>
      <Footer />
    </Wrapper>
  );
};

export default CancelPage;

// Styled
const Wrapper = styled.div`
  min-height: 100vh;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  padding: 4rem 2rem;
  text-align: center;
  flex-grow: 1;

  h2 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    color: #dc2626;
  }

  p {
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  button {
    background: #ef4444;
    color: white;
    padding: 0.8rem 2rem;
    font-size: 1rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background: #b91c1c;
    }
  }
`;
